import DialogTitle from '@components/mui/DialogTitle'
import { Dialog, DialogContent } from '@mui/material'

import Version from './Version'

type Props = {
	open: boolean
	onClose: () => void
}

export default function Help({ open, onClose }: Props) {
	if (!open) return null

	return (
		<Dialog fullWidth open onClose={onClose} closeAfterTransition={false} disableRestoreFocus>
			<DialogTitle onClose={onClose}>Help</DialogTitle>
			<DialogContent data-testid="help-dialog">
				<Version onClose={onClose} />
			</DialogContent>
		</Dialog>
	)
}
